import React, { useState, useEffect } from 'react';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import RangeSlider from 'react-bootstrap-range-slider';
import Switch from 'react-switch';
// COMPONENTS
import Header from '../../../components/header';
import BuyNow from '../../../components/buyNowSection';
import Carousel from '../../../components/carousel';
import Footer from '../../../components/footer';
// ICONS
import { FaArrowLeft } from 'react-icons/fa';
import { FaSun } from 'react-icons/fa';
import { FaRegSun } from 'react-icons/fa';
// STYLES
import '../styles.css';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router';

const Brightness = () => {
  const history = useHistory();
  const alreadyLoggedIn = localStorage.getItem('token');
  if (!alreadyLoggedIn) {
    history.push('/');
  }
  const [dayBrightness, setDayBrightness] = useState(0);
  const [nightBrightness, setNightBrightness] = useState(0);
  const [dayBrightnessBtn, setDayBrightnessBtn] = useState(0);
  const [nightBrightnessBtn, setNightBrightnessBtn] = useState(0);
  const [check, setCheck] = useState(false);
  const token = localStorage.getItem('token');
  const physicalId = localStorage.getItem('physicalId');
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  };
  toast.configure();

  // day brightness API
  // WO-Button

  useEffect(() => {
    fetch('control/' + physicalId + '/hardware/high-display-brightness', {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setDayBrightness(response?.brightness);
      })
      .catch((error) => console.log(error));
  }, []);

  // W-Button
  useEffect(() => {
    fetch('control/' + physicalId + '/hardware/high-button-brightness', {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setDayBrightnessBtn(response?.brightness);
      })
      .catch((error) => console.log(error));
  }, []);

  // night brightness API
  // WO-Button
  //THIS WILL NOT USED CURRENTLY

  // useEffect(() => {
  //   fetch('control/' + physicalId + '/hardware/high-button-brightness', {
  //     method: 'PUT',
  //     headers: headers,
  //     body: JSON.stringify({
  //       brightness,
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((response) => {
  //       console.log('NIGHT: ', response);
  //       setNightBrightness(response.brightness);
  //       console.log(nightBrightness);
  //       // console.log(data);
  //     })
  //     .catch((error) => console.log(error));
  // }, []);

  // W-Button
  useEffect(() => {
    fetch('control/' + physicalId + '/hardware/low-display-brightness', {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setNightBrightness(response?.brightness);
        setNightBrightnessBtn(response?.brightness);
      })
      .catch((error) => console.log(error));
  }, []);

  // Set day brightness
  const handleNightBrigthtess = () => {
    fetch('control/' + physicalId + '/hardware/low-display-brightness', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({
        brightness: +nightBrightness,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (+response?.code >= 500) {
          toast.error('Night Brightness not updated, try again', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            // theme: 'colored',
          });
        } else {
          toast.success('Night Brightness updated successfully', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            // theme: 'colored',
          });
        }
      })
      .catch((error) => console.log(error));
  };

  // Set day brightness
  const handleDayBrigthtess = () => {
    // console.log(dayBrightness);
    fetch('control/' + physicalId + '/hardware/high-display-brightness', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({
        brightness: +dayBrightness,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (+response?.code >= 500) {
          toast.error('Brightness not updated, try again', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            // theme: 'colored',
          });
        } else {
          toast.success('Brightness updated successfully', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            // theme: 'colored',
          });
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div class='container'>
          <div class='container-sm-500'>
            <a href='/settings' class='back-arrow'>
              <FaArrowLeft />
            </a>
            <h2 class='text-left'>BRIGHTNESS</h2>

            <div class='custom-range-slider'>
              <label class='custom-label mb-3 mt-5'>
                Day Brightness : <span class='output'>{dayBrightness}</span>%
              </label>
              <div class='brightness'>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <FaRegSun size={24} />
                  <FaSun size={24} />
                </div>
                <RangeSlider
                  style={{}}
                  value={dayBrightness}
                  onChange={(e) => {
                    setDayBrightness(e.target.value);
                  }}
                  onAfterChange={(e) => {
                    handleDayBrigthtess();
                  }}
                  tooltip='off'
                  variant='light'
                  size='lg'
                />
              </div>
            </div>

            <div class='custom-range-slider mt-3'>
              <label class='custom-label mb-3 mt-5'>
                Night Brightness :{' '}
                <span class='output2'>{nightBrightness}</span>%
              </label>
              <div class='brightness'>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <FaRegSun size={24} />
                  <FaSun size={24} />
                </div>
                <RangeSlider
                  style={{ width: '100%' }}
                  value={nightBrightness}
                  onChange={(changeEvent) =>
                    setNightBrightness(changeEvent.target.value)
                  }
                  onAfterChange={(e) => {
                    handleNightBrigthtess();
                  }}
                  tooltip='off'
                  variant='light'
                  size='lg'
                />
              </div>
            </div>

            <div class='use-24 mt-5'>
              <p>Match display and buttons:</p>
              <div class='custom-control custom-switch'>
                <Switch
                  onChange={() => setCheck(!check)}
                  checked={check}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor='#707070'
                  onColor='#49c85a'
                />
                <label class='custom-control-label' for='customSwitch1'></label>
              </div>
            </div>

            {!check ? (
              <div>
                <div class='custom-range-slider'>
                  <label class='custom-label mb-3 mt-5'>
                    Day Brightness :{' '}
                    <span class='output'>{dayBrightnessBtn}</span>%
                  </label>
                  <div class='brightness'>
                    <div
                      style={{
                        flexDirection: 'row',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FaRegSun size={24} />
                      <FaSun size={24} />
                    </div>
                    <RangeSlider
                      style={{}}
                      value={
                        check
                          ? dayBrightnessBtn
                          : dayBrightnessBtn === dayBrightness
                      }
                      onChange={(changeEvent) =>
                        setDayBrightnessBtn(changeEvent.target.value)
                      }
                      tooltip='off'
                      variant='light'
                      size='lg'
                      disabled
                    />
                  </div>
                </div>

                <div class='custom-range-slider mt-3'>
                  <label class='custom-label mb-3 mt-5'>
                    Night Brightness :{' '}
                    <span class='output2'>{nightBrightnessBtn}</span>%
                  </label>
                  <div class='brightness'>
                    <div
                      style={{
                        flexDirection: 'row',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FaRegSun size={24} />
                      <FaSun size={24} />
                    </div>
                    <RangeSlider
                      style={{ width: '100%' }}
                      value={
                        check
                          ? nightBrightnessBtn
                          : nightBrightnessBtn === nightBrightness
                      }
                      onChange={(changeEvent) =>
                        setNightBrightnessBtn(changeEvent.target.value)
                      }
                      tooltip='off'
                      variant='light'
                      size='lg'
                      disabled
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {/* <a href='#' class='white-btn mt-5'>
              Restore to defaults
            </a> */}

            <a href='/advancedBrightness' class='white-btn mt-3'>
              Show Advanced Settings
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default Brightness;
